<template>
    <div>
        <SignUpHeader :current-app="currentApp" v-if="!successful" :title="title"></SignUpHeader>
        <SignUpForm
            :current-app="currentApp"
            v-if="!successful"
            @success="handleSuccess"
            :prefilled-email="prefilledEmail"
            :confirmation-token="confirmationToken"
        ></SignUpForm>
        <SignUpSuccess v-if="successful" :email="email"></SignUpSuccess>
    </div>
</template>

<script>
    import SignUpHeader from './parts/SignUpHeader'
    import SignUpForm from './form/SignUpForm'
    import SignUpSuccess from './parts/SignUpSuccess'
    import translations from '@/translations/sign_up_form/index'

    export default {
        name: 'SignUp',
        props: {
            currentApp: {
                type: String,
                default: 'community'
            },
            prefilledEmail: {
                type: String
            },
            confirmationToken: {
                type: String
            }
        },
        components: {
            SignUpHeader,
            SignUpForm,
            SignUpSuccess
        },
        computed: {
            title () {
                let title = '';
                switch (this.currentApp) {
                    case 'community':
                        title = `Sign up for GrabCAD Community <br> Join ${Grabcad.engineersCount} engineers! Share your ideas and CAD models with the world.`
                        break;
                    case 'print':
                        title = this.$t('actions.print_sign_up');
                        break;
                    case 'workbench':
                        title = this.$t('actions.workbench_sign_up');
                        break;
                    case 'partner_program':
                        title = this.$t('actions.partner_program_sign_up');
                        break;
                    case 'shop':
                        title = this.$t('actions.shop_sign_up');
                        break;
                    default:
                        title = 'Sign up';
                        break;
                }
                return title;
            }
        },
        data () {
            return {
                successful: false,
                email: ''
            }
        },
        methods: {
            handleSuccess (email) {
                window.scrollTo(0,0);

                this.successful = true;
                this.email = email;
            }
        },
        i18n: {
            messages: translations
        }
    }
</script>

<style lang="scss" scoped>
    .sign-up-page {
        text-transform: none;
    }
</style>
<style>
    sign-up {
        min-height: 821px;
        display: block;
        width: 100%;
        background-color: #F3F3F3;
    }

    sign-up:before {
        content: "";
        height: 150px;
        background: linear-gradient(180deg, #7A7A7A 0%, #4F4F4F 100%);
        width: 100%;
        display: block;
    }
</style>
